import type * as THREE from "three";
import type { CSS2DRenderer } from "three/examples/jsm/renderers/CSS2DRenderer.js";
import { createToken, type IService } from "@designboticteam/core";

const RENDERER_SERVICE = createToken<IRendererService>("IRendererService");

type RenderLoopListener = () => void;

interface IRendererService extends IService {
	renderer3D: THREE.WebGLRenderer;
	renderer2D: CSS2DRenderer;
	addRenderLoopListener(listener: RenderLoopListener): void;
	removeRenderLoopListener(listener: RenderLoopListener): void;
	setPixelRatio(value: number): void;
}

export { type IRendererService, RENDERER_SERVICE, type RenderLoopListener };
